export const CATEGORIES = [
  { key: "actor", label: "Actor" },
  { key: "singer", label: "Singer" },
  { key: "dancer", label: "Dancer" },
  { key: "model", label: "Model" },
  { key: "voice-artist", label: "Voice Artist" },
  { key: "comedian", label: "Comedian" },
  { key: "poet", label: "Poet" },
  { key: "photographer", label: "Photographer" },
  { key: "musician", label: "Musician" },
  { key: "painter", label: "Painter" },
  { key: "magician", label: "Magician" },
  { key: "mimicry-artist", label: "Mimicry Artist" },
  { key: "anchor-host", label: "Anchor / Host" },
  { key: "rj", label: "RJ" },
  { key: "vj", label: "VJ" },
  { key: "standup-comedian", label: "Standup Comedian" },
  { key: "storyteller", label: "Storyteller" },
  { key: "writer", label: "Writer" },
  { key: "chef", label: "Chef" },
  { key: "makeup-artist", label: "Makeup Artist" },
  { key: "fashion-designer", label: "Fashion Designer" },
  { key: "stylist", label: "Stylist" },
  { key: "choreographer", label: "Choreographer" },
  { key: "dj", label: "DJ" },
  { key: "filmmaker", label: "Filmmaker" },
  { key: "cinematographer", label: "Cinematographer" },
  { key: "editor", label: "Editor" },
  { key: "illustrator", label: "Illustrator" },
  { key: "cartoonist", label: "Cartoonist" },
  { key: "tattoo-artist", label: "Tattoo Artist" },
  { key: "mehendi-artist", label: "Mehendi Artist" },
  { key: "other", label: "Other" },
];

export const catLabel = (k) => CATEGORIES.find((c) => c.key === k)?.label || k;

// Mapping talent category -> training-ad category. Used to auto-filter
// Training Advertisements on category-scoped feeds. Keys in sync with
// backend `models/training_ad.TALENT_TO_TRAINING`.
export const TALENT_TO_TRAINING = {
  "actor":            "acting_schools",
  "dancer":           "dance_academies",
  "singer":           "singing_institutes",
  "model":            "modeling_institutes",
  "voice-artist":     "voice_over_classes",
  "anchor-host":      "anchoring_institutes",
  "rj":               "anchoring_institutes",
  "vj":               "anchoring_institutes",
  "photographer":     "photography_institutes",
  "makeup-artist":    "makeup_academies",
  "standup-comedian": "acting_schools",
  "comedian":         "acting_schools",
};

export const PLAN_META = {
  free: { name: "Free", price: 0, videos: 3, dur: 45, color: "text-zinc-300" },
  plus: { name: "Plus", price: 299, videos: 7, dur: 45, color: "text-[#DC2626]" },
  pro:  { name: "Pro",  price: 499, videos: 20, dur: 60, color: "text-[#FCA5A5]" },
};
